"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACUnitIcon: function() {
        return _ac_unitsvg.default;
    },
    AccessibleIcon: function() {
        return _accessiblesvg.default;
    },
    AccountCircleIcon: function() {
        return _account_circlesvg.default;
    },
    AddBoxIcon: function() {
        return _add_box_iconsvg.default;
    },
    AddDiamondIcon: function() {
        return _add_diamond_iconsvg.default;
    },
    AddLocationIcon: function() {
        return _add_locationsvg.default;
    },
    AddOutlineIcon: function() {
        return _add_circle_outlinesvg.default;
    },
    Aeroplane: function() {
        return _airplanesvg.default;
    },
    AirportLocationIcon: function() {
        return _airport_locationsvg.default;
    },
    AlertIcon: function() {
        return _alertsvg.default;
    },
    AppleStoreIcon: function() {
        return _appleStoresvg.default;
    },
    ArrowBack: function() {
        return _arrowbacksvg.default;
    },
    ArrowDown: function() {
        return _arrowdownsvg.default;
    },
    ArrowDownward: function() {
        return _arrow_downwardsvg.default;
    },
    ArrowForward: function() {
        return _arrowforwardsvg.default;
    },
    ArrowLeft: function() {
        return _arrowleftsvg.default;
    },
    ArrowToRight: function() {
        return _arrow_to_rightsvg.default;
    },
    ArrowUpward: function() {
        return _arrow_upwardsvg.default;
    },
    BackArrow: function() {
        return _backarrowsvg.default;
    },
    BadgeIcon: function() {
        return _badgesvg.default;
    },
    BedtimeIcon: function() {
        return _bedtimesvg.default;
    },
    Bell: function() {
        return _bellsvg.default;
    },
    BurgerNav: function() {
        return _burgernavsvg.default;
    },
    Calendar: function() {
        return _calendarsvg.default;
    },
    CalendarB: function() {
        return _calendarbluesvg.default;
    },
    Cart: function() {
        return _cartsvg.default;
    },
    CatalogueIcon: function() {
        return _cataloguesvg.default;
    },
    ChairIcon: function() {
        return _chairsvg.default;
    },
    Chat: function() {
        return _chatsvg.default;
    },
    Check: function() {
        return _checksvg.default;
    },
    CheckCircle: function() {
        return _check_circlesvg.default;
    },
    ChevronLeft: function() {
        return _chevronleftsvg.default;
    },
    ChevronRight: function() {
        return _chevronrightsvg.default;
    },
    ChildCareIcon: function() {
        return _child_caresvg.default;
    },
    CleaningServicesIcon: function() {
        return _cleaning_servicessvg.default;
    },
    Clock: function() {
        return _clocksvg.default;
    },
    Close: function() {
        return _closesvg.default;
    },
    CloseIcon: function() {
        return _icon_closesvg.default;
    },
    Coffee: function() {
        return _coffeesvg.default;
    },
    Confirmed: function() {
        return _confirmedsvg.default;
    },
    ContentManagementIcon: function() {
        return _content_managementsvg.default;
    },
    DataInsightsIcon: function() {
        return _data_insightssvg.default;
    },
    DataInsightsIconLarge: function() {
        return _data_insights_largesvg.default;
    },
    Declined: function() {
        return _declinedsvg.default;
    },
    DeleteIcon: function() {
        return _deletesvg.default;
    },
    DiningIcon: function() {
        return _diningsvg.default;
    },
    DragIndicator: function() {
        return _drag_indicatorsvg.default;
    },
    Edit: function() {
        return _editsvg.default;
    },
    EditDetailsIcon: function() {
        return _editdetailssvg.default;
    },
    ExpendLess: function() {
        return _expand_lesssvg.default;
    },
    ExpendMore: function() {
        return _expand_moresvg.default;
    },
    ExperienceX: function() {
        return _experiencexsvg.default;
    },
    FastFoodIcon: function() {
        return _fastfoodsvg.default;
    },
    FastFwdIcon: function() {
        return _fast_forwardsvg.default;
    },
    FerryLocationIcon: function() {
        return _ferry_locationsvg.default;
    },
    Filter: function() {
        return _filtersvg.default;
    },
    FitScreen: function() {
        return _fit_screensvg.default;
    },
    FitnessCenterIcon: function() {
        return _fitness_centersvg.default;
    },
    FlightTakeOffIcon: function() {
        return _flight_takeoffsvg.default;
    },
    FourSquares: function() {
        return _foursquaressvg.default;
    },
    GoogleMapsIcon: function() {
        return _google_mapssvg.default;
    },
    GoogleStoreIcon: function() {
        return _googleStoresvg.default;
    },
    GreenCircle: function() {
        return _greencirclesvg.default;
    },
    HelpOutlineIcon: function() {
        return _help_outlinesvg.default;
    },
    History: function() {
        return _historysvg.default;
    },
    Home: function() {
        return _homesvg.default;
    },
    InfoIcon: function() {
        return _infosvg.default;
    },
    KeyboardArrowDownIcon: function() {
        return _keyboard_arrow_downsvg.default;
    },
    KeyboardReturn: function() {
        return _keyboard_returnsvg.default;
    },
    LocalBarIcon: function() {
        return _local_barsvg.default;
    },
    LocalCafeIcon: function() {
        return _local_cafesvg.default;
    },
    LocalDrinkIcon: function() {
        return _local_drinksvg.default;
    },
    Logout: function() {
        return _logoutsvg.default;
    },
    Lounge: function() {
        return _loungesvg.default;
    },
    LoungeManagementIcon: function() {
        return _lounge_managementsvg.default;
    },
    Magglass: function() {
        return _magglasssvg.default;
    },
    MaintenanceIcon: function() {
        return _maintenanceiconsvg.default;
    },
    MapPin: function() {
        return _mappinsvg.default;
    },
    MeetingRoomIcon: function() {
        return _meeting_roomsvg.default;
    },
    MenuIcon: function() {
        return _menusvg.default;
    },
    MinusIcon: function() {
        return _minus_iconsvg.default;
    },
    NewspaperIcon: function() {
        return _newspapersvg.default;
    },
    OperationalSupportIcon: function() {
        return _operational_supportsvg.default;
    },
    OutletLoungeIcon: function() {
        return _outletloungesvg.default;
    },
    OutletRefreshIcon: function() {
        return _spasvg.default;
    },
    OutletRestIcon: function() {
        return _bedtimesvg.default;
    },
    OutletRestaurantIcon: function() {
        return _restaurantsvg.default;
    },
    OutletServicesIcon: function() {
        return _room_servicesvg.default;
    },
    OutletUnwindIcon: function() {
        return _self_improvementsvg.default;
    },
    PaymentIcon: function() {
        return _paymentsvg.default;
    },
    PaymentsInvoicingIcon: function() {
        return _payments_invoicingsvg.default;
    },
    Pencil: function() {
        return _pencilsvg.default;
    },
    Pending: function() {
        return _pendingsvg.default;
    },
    PhotoLibrary: function() {
        return _photo_librarysvg.default;
    },
    Plus: function() {
        return _plussvg.default;
    },
    QuestionMarkWithCircle: function() {
        return _questionmarkcirclesvg.default;
    },
    RailwayLocationIcon: function() {
        return _railway_locationsvg.default;
    },
    RedCircle: function() {
        return _redcirclesvg.default;
    },
    Reject: function() {
        return _rejectsvg.default;
    },
    RemoveOutlineIcon: function() {
        return _remove_circle_outlinesvg.default;
    },
    Search: function() {
        return _searchsvg.default;
    },
    SearchOutlet: function() {
        return _searchoutletsvg.default;
    },
    SearchV2: function() {
        return _search_v2svg.default;
    },
    ShowerIcon: function() {
        return _showersvg.default;
    },
    SmartphoneIcon: function() {
        return _smartphonesvg.default;
    },
    SquareIcon: function() {
        return _square_iconsvg.default;
    },
    StarIcon: function() {
        return _starsvg.default;
    },
    TrainingIcon: function() {
        return _trainingsvg.default;
    },
    TranslationIcon: function() {
        return _translation_iconsvg.default;
    },
    TvIcon: function() {
        return _tvsvg.default;
    },
    Union: function() {
        return _unionsvg.default;
    },
    Upload: function() {
        return _uploadsvg.default;
    },
    UsbIcon: function() {
        return _usbsvg.default;
    },
    WarningAmber: function() {
        return _warning_ambersvg.default;
    },
    WarningIcon: function() {
        return _warningsvg.default;
    },
    WarningRed: function() {
        return _warning_redsvg.default;
    },
    WcIcon: function() {
        return _wcsvg.default;
    },
    WifiIcon: function() {
        return _wifisvg.default;
    }
});
var _bellsvg = /*#__PURE__*/ _interop_require_default(require("./bell.svg"));
var _burgernavsvg = /*#__PURE__*/ _interop_require_default(require("./burger-nav.svg"));
var _cartsvg = /*#__PURE__*/ _interop_require_default(require("./cart.svg"));
var _chatsvg = /*#__PURE__*/ _interop_require_default(require("./chat.svg"));
var _checksvg = /*#__PURE__*/ _interop_require_default(require("./check.svg"));
var _chevronleftsvg = /*#__PURE__*/ _interop_require_default(require("./chevron-left.svg"));
var _chevronrightsvg = /*#__PURE__*/ _interop_require_default(require("./chevron-right.svg"));
var _clocksvg = /*#__PURE__*/ _interop_require_default(require("./clock.svg"));
var _closesvg = /*#__PURE__*/ _interop_require_default(require("./close.svg"));
var _experiencexsvg = /*#__PURE__*/ _interop_require_default(require("./experience-x.svg"));
var _filtersvg = /*#__PURE__*/ _interop_require_default(require("./filter.svg"));
var _homesvg = /*#__PURE__*/ _interop_require_default(require("./home.svg"));
var _loungesvg = /*#__PURE__*/ _interop_require_default(require("./lounge.svg"));
var _mappinsvg = /*#__PURE__*/ _interop_require_default(require("./map-pin.svg"));
var _searchsvg = /*#__PURE__*/ _interop_require_default(require("./search.svg"));
var _coffeesvg = /*#__PURE__*/ _interop_require_default(require("./coffee.svg"));
var _calendarsvg = /*#__PURE__*/ _interop_require_default(require("./calendar.svg"));
var _logoutsvg = /*#__PURE__*/ _interop_require_default(require("./logout.svg"));
var _pendingsvg = /*#__PURE__*/ _interop_require_default(require("./pending.svg"));
var _confirmedsvg = /*#__PURE__*/ _interop_require_default(require("./confirmed.svg"));
var _declinedsvg = /*#__PURE__*/ _interop_require_default(require("./declined.svg"));
var _backarrowsvg = /*#__PURE__*/ _interop_require_default(require("./back-arrow.svg"));
var _infosvg = /*#__PURE__*/ _interop_require_default(require("./info.svg"));
var _warningsvg = /*#__PURE__*/ _interop_require_default(require("./warning.svg"));
var _editsvg = /*#__PURE__*/ _interop_require_default(require("./edit.svg"));
var _airplanesvg = /*#__PURE__*/ _interop_require_default(require("./airplane.svg"));
var _calendarbluesvg = /*#__PURE__*/ _interop_require_default(require("./calendarblue.svg"));
var _magglasssvg = /*#__PURE__*/ _interop_require_default(require("./magglass.svg"));
var _greencirclesvg = /*#__PURE__*/ _interop_require_default(require("./greencircle.svg"));
var _redcirclesvg = /*#__PURE__*/ _interop_require_default(require("./redcircle.svg"));
var _arrowdownsvg = /*#__PURE__*/ _interop_require_default(require("./arrowdown.svg"));
var _arrowleftsvg = /*#__PURE__*/ _interop_require_default(require("./arrowleft.svg"));
var _foursquaressvg = /*#__PURE__*/ _interop_require_default(require("./foursquares.svg"));
var _pencilsvg = /*#__PURE__*/ _interop_require_default(require("./pencil.svg"));
var _maintenanceiconsvg = /*#__PURE__*/ _interop_require_default(require("./maintenance-icon.svg"));
var _alertsvg = /*#__PURE__*/ _interop_require_default(require("./alert.svg"));
var _appleStoresvg = /*#__PURE__*/ _interop_require_default(require("./appleStore.svg"));
var _googleStoresvg = /*#__PURE__*/ _interop_require_default(require("./googleStore.svg"));
var _starsvg = /*#__PURE__*/ _interop_require_default(require("./star.svg"));
var _cataloguesvg = /*#__PURE__*/ _interop_require_default(require("./catalogue.svg"));
var _outletloungesvg = /*#__PURE__*/ _interop_require_default(require("./outlet-lounge.svg"));
var _restaurantsvg = /*#__PURE__*/ _interop_require_default(require("./restaurant.svg"));
var _bedtimesvg = /*#__PURE__*/ _interop_require_default(require("./bedtime.svg"));
var _room_servicesvg = /*#__PURE__*/ _interop_require_default(require("./room_service.svg"));
var _self_improvementsvg = /*#__PURE__*/ _interop_require_default(require("./self_improvement.svg"));
var _spasvg = /*#__PURE__*/ _interop_require_default(require("./spa.svg"));
var _account_circlesvg = /*#__PURE__*/ _interop_require_default(require("./account_circle.svg"));
var _menusvg = /*#__PURE__*/ _interop_require_default(require("./menu.svg"));
var _keyboard_arrow_downsvg = /*#__PURE__*/ _interop_require_default(require("./keyboard_arrow_down.svg"));
var _chairsvg = /*#__PURE__*/ _interop_require_default(require("./chair.svg"));
var _help_outlinesvg = /*#__PURE__*/ _interop_require_default(require("./help_outline.svg"));
var _fit_screensvg = /*#__PURE__*/ _interop_require_default(require("./fit_screen.svg"));
var _warning_ambersvg = /*#__PURE__*/ _interop_require_default(require("./warning_amber.svg"));
var _accessiblesvg = /*#__PURE__*/ _interop_require_default(require("./accessible.svg"));
var _ac_unitsvg = /*#__PURE__*/ _interop_require_default(require("./ac_unit.svg"));
var _flight_takeoffsvg = /*#__PURE__*/ _interop_require_default(require("./flight_takeoff.svg"));
var _usbsvg = /*#__PURE__*/ _interop_require_default(require("./usb.svg"));
var _smartphonesvg = /*#__PURE__*/ _interop_require_default(require("./smartphone.svg"));
var _wcsvg = /*#__PURE__*/ _interop_require_default(require("./wc.svg"));
var _tvsvg = /*#__PURE__*/ _interop_require_default(require("./tv.svg"));
var _badgesvg = /*#__PURE__*/ _interop_require_default(require("./badge.svg"));
var _fast_forwardsvg = /*#__PURE__*/ _interop_require_default(require("./fast_forward.svg"));
var _newspapersvg = /*#__PURE__*/ _interop_require_default(require("./newspaper.svg"));
var _child_caresvg = /*#__PURE__*/ _interop_require_default(require("./child_care.svg"));
var _showersvg = /*#__PURE__*/ _interop_require_default(require("./shower.svg"));
var _meeting_roomsvg = /*#__PURE__*/ _interop_require_default(require("./meeting_room.svg"));
var _fitness_centersvg = /*#__PURE__*/ _interop_require_default(require("./fitness_center.svg"));
var _cleaning_servicessvg = /*#__PURE__*/ _interop_require_default(require("./cleaning_services.svg"));
var _local_drinksvg = /*#__PURE__*/ _interop_require_default(require("./local_drink.svg"));
var _local_barsvg = /*#__PURE__*/ _interop_require_default(require("./local_bar.svg"));
var _local_cafesvg = /*#__PURE__*/ _interop_require_default(require("./local_cafe.svg"));
var _diningsvg = /*#__PURE__*/ _interop_require_default(require("./dining.svg"));
var _fastfoodsvg = /*#__PURE__*/ _interop_require_default(require("./fastfood.svg"));
var _wifisvg = /*#__PURE__*/ _interop_require_default(require("./wifi.svg"));
var _paymentsvg = /*#__PURE__*/ _interop_require_default(require("./payment.svg"));
var _questionmarkcirclesvg = /*#__PURE__*/ _interop_require_default(require("./questionmarkcircle.svg"));
var _editdetailssvg = /*#__PURE__*/ _interop_require_default(require("./edit-details.svg"));
var _check_circlesvg = /*#__PURE__*/ _interop_require_default(require("./check_circle.svg"));
var _unionsvg = /*#__PURE__*/ _interop_require_default(require("./union.svg"));
var _plussvg = /*#__PURE__*/ _interop_require_default(require("./plus.svg"));
var _icon_closesvg = /*#__PURE__*/ _interop_require_default(require("./icon_close.svg"));
var _keyboard_returnsvg = /*#__PURE__*/ _interop_require_default(require("./keyboard_return.svg"));
var _arrow_upwardsvg = /*#__PURE__*/ _interop_require_default(require("./arrow_upward.svg"));
var _arrow_downwardsvg = /*#__PURE__*/ _interop_require_default(require("./arrow_downward.svg"));
var _searchoutletsvg = /*#__PURE__*/ _interop_require_default(require("./search-outlet.svg"));
var _arrow_to_rightsvg = /*#__PURE__*/ _interop_require_default(require("./arrow_to_right.svg"));
var _historysvg = /*#__PURE__*/ _interop_require_default(require("./history.svg"));
var _warning_redsvg = /*#__PURE__*/ _interop_require_default(require("./warning_red.svg"));
var _photo_librarysvg = /*#__PURE__*/ _interop_require_default(require("./photo_library.svg"));
var _drag_indicatorsvg = /*#__PURE__*/ _interop_require_default(require("./drag_indicator.svg"));
var _deletesvg = /*#__PURE__*/ _interop_require_default(require("./delete.svg"));
var _rejectsvg = /*#__PURE__*/ _interop_require_default(require("./reject.svg"));
var _uploadsvg = /*#__PURE__*/ _interop_require_default(require("./upload.svg"));
var _add_locationsvg = /*#__PURE__*/ _interop_require_default(require("./add_location.svg"));
var _add_circle_outlinesvg = /*#__PURE__*/ _interop_require_default(require("./add_circle_outline.svg"));
var _remove_circle_outlinesvg = /*#__PURE__*/ _interop_require_default(require("./remove_circle_outline.svg"));
var _square_iconsvg = /*#__PURE__*/ _interop_require_default(require("./square_icon.svg"));
var _minus_iconsvg = /*#__PURE__*/ _interop_require_default(require("./minus_icon.svg"));
var _add_box_iconsvg = /*#__PURE__*/ _interop_require_default(require("./add_box_icon.svg"));
var _add_diamond_iconsvg = /*#__PURE__*/ _interop_require_default(require("./add_diamond_icon.svg"));
var _airport_locationsvg = /*#__PURE__*/ _interop_require_default(require("./airport_location.svg"));
var _ferry_locationsvg = /*#__PURE__*/ _interop_require_default(require("./ferry_location.svg"));
var _railway_locationsvg = /*#__PURE__*/ _interop_require_default(require("./railway_location.svg"));
var _google_mapssvg = /*#__PURE__*/ _interop_require_default(require("./google_maps.svg"));
var _expand_lesssvg = /*#__PURE__*/ _interop_require_default(require("./expand_less.svg"));
var _expand_moresvg = /*#__PURE__*/ _interop_require_default(require("./expand_more.svg"));
var _arrowbacksvg = /*#__PURE__*/ _interop_require_default(require("./arrow-back.svg"));
var _arrowforwardsvg = /*#__PURE__*/ _interop_require_default(require("./arrow-forward.svg"));
var _search_v2svg = /*#__PURE__*/ _interop_require_default(require("./search_v2.svg"));
var _translation_iconsvg = /*#__PURE__*/ _interop_require_default(require("./translation_icon.svg"));
var _data_insightssvg = /*#__PURE__*/ _interop_require_default(require("./data_insights.svg"));
var _lounge_managementsvg = /*#__PURE__*/ _interop_require_default(require("./lounge_management.svg"));
var _operational_supportsvg = /*#__PURE__*/ _interop_require_default(require("./operational_support.svg"));
var _trainingsvg = /*#__PURE__*/ _interop_require_default(require("./training.svg"));
var _content_managementsvg = /*#__PURE__*/ _interop_require_default(require("./content_management.svg"));
var _payments_invoicingsvg = /*#__PURE__*/ _interop_require_default(require("./payments_invoicing.svg"));
var _data_insights_largesvg = /*#__PURE__*/ _interop_require_default(require("./data_insights_large.svg"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
